import { supabase } from '../client';

export interface ClientNote {
  id: string;
  org_id: string;
  client_id: string;
  body: string;
  pinned: boolean;
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export const clientNoteService = {
  async listByClient(clientId: string): Promise<ClientNote[]> {
    const { data, error } = await supabase
      .from('ggj_b2b_client_notes')
      .select('*')
      .eq('client_id', clientId)
      .order('pinned', { ascending: false })
      .order('created_at', { ascending: false });
    if (error) throw error;
    return (data ?? []) as ClientNote[];
  },

  async create(orgId: string, clientId: string, body: string, createdBy?: string): Promise<ClientNote> {
    const { data, error } = await supabase
      .from('ggj_b2b_client_notes')
      .insert({ org_id: orgId, client_id: clientId, body, created_by: createdBy ?? null })
      .select()
      .single();
    if (error) throw error;
    return data as ClientNote;
  },

  async update(id: string, body: string): Promise<ClientNote> {
    const { data, error } = await supabase
      .from('ggj_b2b_client_notes')
      .update({ body })
      .eq('id', id)
      .select()
      .single();
    if (error) throw error;
    return data as ClientNote;
  },

  async togglePin(id: string, pinned: boolean): Promise<void> {
    const { error } = await supabase
      .from('ggj_b2b_client_notes')
      .update({ pinned })
      .eq('id', id);
    if (error) throw error;
  },

  async delete(id: string): Promise<void> {
    const { error } = await supabase
      .from('ggj_b2b_client_notes')
      .delete()
      .eq('id', id);
    if (error) throw error;
  },
};
